'use client';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { ChevronChevronNormalRight } from '@s7/icons';
import { Stack, Group } from '@s7/layout';
import { rem } from '@s7/styles';
import { Typography, Highlight } from '@s7/ui';
import { useMediaQueryContext } from '../../../../Footer.context.js';
import { HelpCenterItemHint } from './HelpCenterItemHint.js';
import { SearchItemButton } from '../SearchItemButton/SearchItemButton.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultTitleProps = {
    breakpoints: {
        'md1.up': {
            color: 'text.primary',
            size: 'md1',
            weight: 400
        }
    },
    weight: 700,
    size: 'sm1',
    lineClamp: 1,
    sx: {
        textAlign: 'start'
    }
};
const defaultDescriptionProps = {
    size: 'xs1',
    lineClamp: 3,
    sx: {
        textAlign: 'start'
    }
};
const HelpCenterItem = (props)=>{
    const { title, hint, description, highlight } = props, others = _object_without_properties_loose(props, [
        "title",
        "hint",
        "description",
        "highlight"
    ]);
    const [isDesktop] = useMediaQueryContext();
    const Chevron = /*#__PURE__*/ jsx(ChevronChevronNormalRight, {
        color: "text.quaternary",
        sx: {
            display: 'flex',
            minWidth: rem(16)
        }
    });
    if (!isDesktop) {
        return /*#__PURE__*/ jsx(SearchItemButton, _extends({}, others, {
            children: /*#__PURE__*/ jsxs(Stack, {
                spacing: 12,
                children: [
                    hint && /*#__PURE__*/ jsx(HelpCenterItemHint, {
                        isDesktop: isDesktop,
                        children: hint
                    }),
                    /*#__PURE__*/ jsxs(Group, {
                        align: "start",
                        position: "apart",
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ jsxs(Stack, {
                                spacing: 12,
                                children: [
                                    title && /*#__PURE__*/ jsx(Typography, _extends({}, defaultTitleProps, {
                                        children: title
                                    })),
                                    description && /*#__PURE__*/ jsx(Highlight, _extends({}, defaultDescriptionProps, {
                                        highlight: highlight,
                                        children: description
                                    }))
                                ]
                            }),
                            Chevron
                        ]
                    })
                ]
            })
        }));
    }
    return /*#__PURE__*/ jsx(SearchItemButton, _extends({}, others, {
        children: /*#__PURE__*/ jsxs(Group, {
            position: "apart",
            noWrap: true,
            children: [
                title && /*#__PURE__*/ jsx(Highlight, _extends({}, defaultTitleProps, {
                    highlight: highlight,
                    children: title
                })),
                hint && /*#__PURE__*/ jsxs(Group, {
                    align: "center",
                    spacing: 40,
                    sx: {
                        paddingLeft: rem(16)
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ jsx(HelpCenterItemHint, {
                            isDesktop: isDesktop,
                            children: hint
                        }),
                        Chevron
                    ]
                })
            ]
        })
    }));
};

export { HelpCenterItem };
//# sourceMappingURL=HelpCenterItem.js.map
